import React from 'react';
import styled from 'styled-components';
import CloseButton from './CloseButton';
import SearchButton from './SearchButton';

const TreeInfoWrap = styled.div`
  /* position: absolute;
  top: 0;
  left: 0; */
  width: 100%;
  /* max-width: 400px; */
  /* padding: 15px; */
`;

const TreeInfoInner = styled.div`
  position: relative;
  width: 100%;
  background-color: #fff;
  padding: 50px 10px 10px;
  /* box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15); */
  /* border-radius: 10px; */
`;

const TreeInfoTop = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0 0 10px;
  margin: 0 0 15px;
  border-bottom: 1px solid #ccc;
`;

const TreeInfoTopTitle = styled.div`
  flex: 1;
  text-align: center;
  text-transform: uppercase;
`;

const TreeInfoTopNav = styled.div`
  flex: 0 0 80px;

  > button {
    width: 100%;
    font-size: 0.75em;
    background: none;
    border: 0;
    cursor: pointer;
  }

`;

const TreeInfoClose = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
`;

const TreeInfoSearch = styled.div`
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
`;

const TreeLocation = styled.h1`
  font-size: 1rem;
  color: #333;
  font-weight: 700;
  margin: 0 0 0;
`;

const TreePlaque = styled.h2`
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0 0 1em;
  text-align: center;
`;

const TreeTable = styled.table`
  font-size: 0.75rem;
  text-align: left;
  border-spacing: 0;

  th, td {
    vertical-align: top;
    padding: 6px;
  }

  th {
    width: 100px;
    padding: 6px 10px;
    border-right: 1px solid #ccc;
  }

`;

const TreeInfoImage = styled.div`
  width: 100%;
  padding: 50% 0 0;
  margin: 0 0 10px;
  background: no-repeat center center/cover #f7f7f7;
`;

const TreeNotSelected = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  margin: 0 auto 0;
  text-align: center;
  color: #333;
  max-width: 250px;
`;

const tableRows = [
  { key: 'fullName', label: 'Full Name' },
  { key: 'rank', label: 'Rank' },
  { key: 'roll', label: 'Roll' },
  { key: 'serviceNumber', label: 'Service Number' },
  { key: 'age', label: 'Age' },
  { key: 'fate', label: 'Fate' },
];

const TreeInfo = (props) => {
  const { trees, selectedTree, setSelectedTree, openSearch } = props;
  //if (!selectedTree) return null;
  const tree = trees[selectedTree];
  const treeKeys = Object.keys(trees);
  const treeIndex = treeKeys.indexOf(selectedTree);

  const nextTreeKey = treeKeys[treeIndex + 1];
  const nextTree = trees[nextTreeKey];
  const prevTreeKey = treeKeys[treeIndex - 1];
  const prevTree = trees[prevTreeKey];

  return (
    <TreeInfoWrap>
      {selectedTree ? (
        <TreeInfoInner>
          <TreeInfoSearch>
            <SearchButton onClick={e => openSearch()} />
          </TreeInfoSearch>
          <TreeInfoClose>
            <CloseButton onClick={e => setSelectedTree(null)} />
          </TreeInfoClose>
          <TreeInfoTop>
            <TreeInfoTopNav>
              {prevTree ? (
                <button onClick={e => setSelectedTree(prevTreeKey)}>&lt; {prevTree.side} {prevTree.number}</button>
              ) : null}
            </TreeInfoTopNav>
            <TreeInfoTopTitle>
              <TreeLocation>{tree.side} {tree.number}</TreeLocation>
            </TreeInfoTopTitle>
            <TreeInfoTopNav>
              {nextTree ? (
                <button onClick={e => setSelectedTree(nextTreeKey)}>{nextTree.side} {nextTree.number} &gt;</button>
              ) : null}
            </TreeInfoTopNav>
          </TreeInfoTop>
          <TreeInfoImage style={{ backgroundImage: `url(images/thumbs/${selectedTree}.jpg)` }} />
          <TreePlaque>{tree.plaque}</TreePlaque>
          <TreeTable>
            <tbody>
              {tableRows.map(row => (
                <tr key={row.key}>
                  <th>{row.label}</th>
                  <td>{tree[row.key]}</td>
                </tr>
              ))}
              <tr>
                <th>Location</th>
                <td>
                  {tree.lat}, {tree.lon}<br /><br />
                  <a href={`https://www.google.com.au/maps/search/?api=1&query=${tree.lat},${tree.lon}`} target="_blank" rel="noopener noreferrer">
                    Get Directions
                  </a>
                  &nbsp; (Opens in Google Maps)
                </td>
              </tr>
            </tbody>
          </TreeTable>
        </TreeInfoInner>
      ): null}
      {!selectedTree ? (
        <TreeInfoInner>
          <TreeInfoSearch>
            <SearchButton onClick={openSearch} />
          </TreeInfoSearch>
          <TreeNotSelected>
            Click a tree on the map, or click the search button above to find a tree...
          </TreeNotSelected>
        </TreeInfoInner>
      ) : null}
    </TreeInfoWrap>
  );
};

export default TreeInfo;
